import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'replace',
    standalone: false
})
export class ReplacePipe implements PipeTransform {
  transform(value?: string | null, strToReplace?: string | null, replacementStr?: string | null): string | null {

    if (!value || !strToReplace) {
      return value ?? null;
    }

    return value.replace(strToReplace, replacementStr ?? '');
  }
}
